import { render, staticRenderFns } from "./RetencionForm.vue?vue&type=template&id=0ff86cb5&scoped=true"
import script from "./RetencionForm.vue?vue&type=script&lang=js"
export * from "./RetencionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff86cb5",
  null
  
)

export default component.exports